import { Box, Checkbox } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { MCOption } from '../teacher/TeacherMCBlock';

export const StudentMCOption = ({
  opt,
  i,
  toggleOption,
  isCorrectPreviewVariant = false,
}: {
  opt: MCOption;
  i: number;
  toggleOption?: (index: number) => void;
  isCorrectPreviewVariant?: boolean;
}): ReactElement => {
  return (
    <Box width="100%" px={isCorrectPreviewVariant ? '0px' : '20px'} py="10px">
      <Checkbox.Root
        key={i}
        checked={isCorrectPreviewVariant ? true : opt.isChecked}
        onCheckedChange={() => toggleOption?.(i)}
        colorScheme="green"
        gap=".8rem"
        textStyle="body.m.regular"
        color={isCorrectPreviewVariant ? 'border.accent.active' : 'text.primary'}
        width="100%"
        cursor={isCorrectPreviewVariant ? 'default' : 'pointer'}
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control
          borderColor="border.accent"
          borderRadius="s"
          width="24px"
          height="24px"
          _checked={{
            backgroundColor: 'background.accent',
            border: 'none',
            color: 'text.onAccent',
          }}
        />
        <Checkbox.Label textStyle="body.m.regular">{opt.text}</Checkbox.Label>
      </Checkbox.Root>
    </Box>
  );
};
